<template>
    <section v-if="data.color" class="hero-item" :style="{backgroundColor: data.color}">
        <div class="inner">
            <div class="cols">
                <figure class="col-3-2 ">
                    <div class="img-wrap img-3x4">
                        <img :src="data.image.sizes.large" :alt="data.image.alt" />
                    </div>
                </figure>
                <Link class="link" v-if="data.link" :post_link="data.link.url" :title="data.link.title" />
                <h2 class="col-3-1" v-html="data.text"></h2>
            </div>
        </div>
    </section>
</template>

<script>
import Link from '@/components/ui/Link.vue';

export default {
    name: 'Hero',

    props: {
        data: {
            type: Object,
            default: {}
        },
    },

    components: {
        Link,
    },

    // mounted() {
    //     console.log(this.data)
    // },
}
</script>
<style lang="scss">
    .hero-item {
        padding-top: 50px;
        padding-bottom: var(--padding-x3);

        h2 {
            font-size: var(--title-size);
            color: white;
        }

        .cols {
            position: relative;
        }

        .link {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            z-index: 3;

            &:hover + h2 {
                color: var(--font-color);
            }
        }
    }

    @media only screen and (max-width: 780px) {
        .hero-item {
            padding-top: var(--padding);
            padding-bottom: var(--padding);

            .col-3-1 {
                padding-top: var(--padding-50);
            }
        }

    }
</style>